// Generated by CoffeeScript 2.7.0
var HierarchicalMenu, hierarchical_menu_node_comp, hierarchical_menu_tree_comp;

hierarchical_menu_node_comp = Vue.extend({
  name: 'hierarchical-menu-node',
  template: `<div class='hierarchical-menu-node' :class='nodeClassObj'>
  <div class='node-wrapper justify-box' @click.stop='activeNodeFunc'>
    <div class='content node-name text-ellipsis'
         :style="{ paddingLeft: (parentLevel - 1) * 1 + 'rem' }">
      <i :class='togglerClassObj' @click.stop='expandNodeFunc'></i>
      <span>{{ node.title }}</span>
    </div>
    <slot name='node-decoration' :node='node'></slot>
    <div class='node-active-flag'>
      <i :class='nodeActiveClassObj' class='gray-text'></i>
    </div>
  </div>
  <div class='node-children'>
    <hierarchical-menu-node
      v-for='child in node.children'
      :key='child.id'
      :node='child'
      :activedNodeId='activedNodeId'
      :parentLevel='parentLevel + 1'
      ref='children'
      @valueChanged='valueChangedFunc'>
      <template slot='node-decoration' slot-scope='{ node }'>
        <slot name='node-decoration' :node='node'></slot>
      </template>
    </hierarchical-menu-node>
  </div>
</div>`,
  props: {
    node: Object,
    activedNodeId: Number,
    parentLevel: {
      type: Number,
      default: 1
    }
  },
  data: function() {
    return {
      expanded: false
    };
  },
  computed: {
    level: function() {
      return this.node.path_ids.length;
    },
    actived: function() {
      return this.activedNodeId === this.node.id;
    },
    // class objects
    nodeClassObj: function() {
      return {
        expanded: this.expanded
      };
    },
    togglerClassObj: function() {
      if (this.node.isLeaf) {
        return {
          'slp-empty': true
        };
      } else {
        return {
          'slp-chevron-right': !this.expanded,
          'slp-chevron-down': this.expanded
        };
      }
    },
    nodeActiveClassObj: function() {
      return {
        'slp-check': this.actived,
        'slp-empty': !this.actived
      };
    }
  },
  watch: {
    actived: function(val, oldVal) {
      if (val) {
        return this.$emit('valueChanged', this.node);
      }
    }
  },
  created: function() {
    if (this.actived) {
      return this.activeNodeFunc();
    }
  },
  methods: {
    activeNodeFunc: function() {
      return this.$emit('valueChanged', this.node);
    },
    expandNodeFunc: function() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        return this._fetchChildren();
      }
    },
    valueChangedFunc: function(node) {
      this.expanded = true;
      return this.$emit('valueChanged', node);
    },
    _fetchChildren: function() {
      if (this.node.children_count === 0) {
        return;
      }
      if (this.node.children_count === this.node.children.length) {
        return;
      }
      return Skylark.Libs.Ajax.get(`${this.node.hierarchy.resources}/${this.node.id}/children`, {
        responseType: 'json',
        success: (rawNodes) => {
          return this.node.hierarchy.addNodes(rawNodes);
        }
      });
    }
  }
});

hierarchical_menu_tree_comp = Vue.extend({
  components: {
    'hierarchical-menu-node': hierarchical_menu_node_comp
  },
  template: `<div class='hierarchical-menu-tree'>
  <hierarchical-menu-node
    :node='tree.root'
    :activedNodeId='activedNodeId'
    ref='root'
    @valueChanged='valueChangedFunc'>
    <template slot='node-decoration' slot-scope='{ node, id }'>
      <slot name='node-decoration' :node='node'></slot>
      <span>{{ id }}</span>
    </template>
  </hierarchical-menu-node>
</div>`,
  props: ['tree', 'activedNodeId'],
  methods: {
    valueChangedFunc: function(node) {
      return this.$emit('valueChanged', node);
    }
  }
});

export default HierarchicalMenu = Vue.extend({
  components: {
    'hierarchical-menu-tree': hierarchical_menu_tree_comp
  },
  template: `<div class='hierarchical-menu'>
  <div class='hierarchical-menu-tree-container'>
    <hierarchical-menu-tree
      v-for='tree in hierarchy.trees'
      :tree='tree'
      :activedNodeId='activedNodeId'
      ref='trees'
      @valueChanged='valueChangedFunc'>
      <template slot='node-decoration' scope='{ node }'>
        <slot name='node-decoration' :node='node'></slot>
      </template>
    </hierarchical-menu-tree>
  </div>
</div>`,
  props: {
    // [必填] 节点请求地址，级联选择格式
    resources: {
      type: String,
      required: true
    },
    // 初始化时激活的节点
    initActivedNodeId: {
      type: Number,
      required: false
    },
    preservedNodes: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      hierarchy: new Skylark.Libs.Hierarchy(),
      activedNodeId: this.initActivedNodeId,
      activedNode: null
    };
  },
  watch: {
    initActivedNodeId: function(val, oldVal) {
      return this.setActivedNodeId(val);
    }
  },
  created: function() {
    this.hierarchy.resources = this.resources;
    this.hierarchy.addNodes(this.preservedNodes);
    return this._initHierarchyWithActivedNode();
  },
  methods: {
    setActivedNodeId: function(id) {
      this.activedNode = null;
      return this.activedNodeId = id;
    },
    valueChangedFunc: function(node) {
      this.activedNode = node;
      this.activedNodeId = node.id;
      return this.$emit('valueChanged', this.activedNode);
    },
    addNode: function(node) {
      var nodes;
      nodes = this.hierarchy.addNodes([node]);
      return _.each(nodes, function(n) {
        if (n.parent) {
          return n.parent.children_count = n.parent.children_count + 1;
        }
      });
    },
    _initHierarchyWithActivedNode: function() {
      var extractRelationship, params, reqUrl;
      params = _.tap({
        enhanced: true,
        include_roots: true,
        attach_ancestors: true,
        attach_siblings: true
      }, (obj) => {
        var actived_id;
        if (!_.isBlank(actived_id = parseInt(this.activedNodeId))) {
          return obj.ids = [actived_id];
        }
      });
      reqUrl = Skylark.Helpers.UrlHelper.generateUrlWithParams(this.resources, params);
      extractRelationship = function(data, name) {
        return _.chain(data).map(function(node) {
          var ref;
          return (ref = node.relationships) != null ? ref[name] : void 0;
        }).flatten().compact().value();
      };
      return Skylark.Libs.Ajax.get(reqUrl, {
        responseType: 'json',
        success: (rsp) => {
          this.hierarchy.addNodes(rsp.included.roots);
          _.each(extractRelationship(rsp.data, 'ancestors'), (ancestor) => {
            this.hierarchy.addNodes([_.omit(ancestor, 'relationships')]);
            if (ancestor.relationships) {
              return this.hierarchy.addNodes(ancestor.relationships.siblings);
            }
          });
          this.hierarchy.addNodes(extractRelationship(rsp.data, 'siblings'));
          return this.hierarchy.addNodes(_.map(rsp.data, function(node) {
            return _.omit(node, 'relationships');
          }));
        }
      });
    }
  }
});
